// Deckbuilder: matches a pasted deck list against deck-index.json (every in-stock card with its
// available variants, rebuilt hourly and served from Shopify Files). No per-card requests:
// the index is downloaded once, then every line is matched in memory to the cheapest
// available variant across all printings. Only exact card names match — a wrong card is worse
// than "not found".
(function () {
  'use strict';

  var INDEX_URL = window.DECK_INDEX_URL || '';
  var indexPromise = null;

  function normalize(s) {
    return String(s).toLowerCase().replace(/[‘’‛′`´]/g, "'").replace(/\s+/g, ' ').trim();
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(n) {
    return Math.round(n).toLocaleString('sr-RS') + ' RSD';
  }

  // "Rhystic Study (45) (PCY)" -> "Rhystic Study"; card names never contain parentheses.
  function cardName(title) {
    var i = title.indexOf(' (');
    return (i === -1 ? title : title.slice(0, i)).trim();
  }

  // index rows: [title, handle, image, [[variantId, price, variantTitle, qty], ...]]
  function buildLookup(idx) {
    var map = new Map();
    function add(key, row) {
      if (!key) return;
      var list = map.get(key);
      if (!list) { list = []; map.set(key, list); }
      list.push(row);
    }
    for (var i = 0; i < idx.rows.length; i++) {
      var row = idx.rows[i];
      var name = cardName(row[0]);
      add(normalize(name), row);
      // Token products ("Labyrinth Guardian // Insect Double-Sided Token") match only by their full
      // name: a front-face alias would put a 25 RSD token in the cart for a "Labyrinth Guardian" line.
      if (/\bToken$/i.test(name)) continue;
      var dfc = name.indexOf(' // ');
      if (dfc > 0) add(normalize(name.slice(0, dfc)), row); // front face of a double-faced card
      var cross = name.indexOf(' - ');
      if (cross > 0) add(normalize(name.slice(cross + 3)), row); // "Flavor Name - Real Name" reprints
    }
    return { map: map, imgBase: idx.imgBase || '', built: idx.built, count: idx.count };
  }

  function loadIndex() {
    if (!indexPromise) {
      indexPromise = fetch(INDEX_URL).then(function (r) {
        if (!r.ok) throw new Error('index HTTP ' + r.status);
        return r.json();
      }).then(buildLookup);
      indexPromise.catch(function () { indexPromise = null; });
    }
    return indexPromise;
  }

  // Every available variant of every printing of a name, cheapest first.
  function offersFor(lookup, name) {
    var rows = lookup.map.get(normalize(name)) || [];
    var offers = [];
    rows.forEach(function (row) {
      row[3].forEach(function (v) {
        offers.push({
          title: row[0], handle: row[1], url: '/products/' + row[1],
          image: row[2] ? lookup.imgBase + row[2] + '?width=300' : '',
          variantId: v[0], price: v[1], variantTitle: v[2], qty: v[3]
        });
      });
    });
    offers.sort(function (a, b) { return a.price - b.price; });
    return offers;
  }

  // "4 Sol Ring", "4x Sol Ring", "Sol Ring", "1 Sol Ring (C21) 263 *F*", "1 Sol Ring [C21]"
  var SKIP = /^(deck|sideboard|commander|maybeboard|companion|main|mainboard)\s*:?$/i;
  function parseDeckList(text) {
    var out = [];
    text.split('\n').forEach(function (raw) {
      var line = raw.trim();
      if (!line || line.charAt(0) === '#' || line.indexOf('//') === 0 || SKIP.test(line)) return;
      var qty = 1, name = line;
      var m = /^(\d+)\s*[xX]?\s+(.+)$/.exec(line);
      if (m) { qty = parseInt(m[1], 10) || 1; name = m[2]; }
      name = name.replace(/\s*\*F\*\s*$/i, '').replace(/\s*\[[^\]]*\]\s*$/, '')
        .replace(/\s*\([A-Za-z0-9]{2,6}\)\s*[A-Za-z0-9-]*\s*$/, '').trim();
      if (name) out.push({ quantity: qty, cardName: name, originalLine: line });
    });
    return out;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var $ = function (id) { return document.getElementById(id); };
    var deckInput = $('deck-input'), searchBtn = $('search-deck'), clearBtn = $('clear-deck');
    var resultsSection = $('results-section'), resultsGrid = $('results-grid');
    var loadingIndicator = $('loading-indicator'), addAllBtn = $('add-all-to-cart');
    var missingCardsSection = $('missing-cards'), missingList = $('missing-list');
    var backBtn = $('back-to-deckbuilder'), inputSection = document.querySelector('.deckbuilder-input-section');
    var lineCount = $('line-count'), cardCount = $('card-count');
    var foundCount = $('found-count'), missingCount = $('missing-count'), totalPrice = $('total-price');
    var catalogInfo = $('catalog-info');

    var lookup = null;
    var searchResults = [];
    var missingCards = [];

    // Start downloading the index right away so the first search is instant.
    loadIndex().then(function (l) {
      lookup = l;
      if (catalogInfo) {
        var t = l.built ? new Date(l.built) : null;
        catalogInfo.textContent = 'Catalog: ' + l.count.toLocaleString('sr-RS') + ' cards in stock' +
          (t ? ', updated ' + t.toLocaleTimeString('sr-RS', { hour: '2-digit', minute: '2-digit' }) : '');
      }
    }).catch(function (e) {
      if (catalogInfo) catalogInfo.textContent = 'Catalog could not be loaded (' + e.message + ')';
    });

    // Data handed over from the mini deckbuilder on the homepage
    var params = new URLSearchParams(window.location.search);
    if (params.get('from-mini') || params.get('quick-search')) {
      try {
        var data = JSON.parse(sessionStorage.getItem('miniDeckbuilderData') || 'null');
        if (data && data.cards) deckInput.value = data.cards;
        sessionStorage.removeItem('miniDeckbuilderData');
      } catch (e) { /* ignore */ }
      if (params.get('quick-search')) setTimeout(function () { searchBtn.click(); }, 50);
    }

    function updateInputStats() {
      var list = parseDeckList(deckInput.value);
      var total = list.reduce(function (s, c) { return s + c.quantity; }, 0);
      lineCount.textContent = list.length + ' lines';
      cardCount.textContent = total + ' cards total';
    }
    deckInput.addEventListener('input', updateInputStats);
    updateInputStats();

    clearBtn.addEventListener('click', function () { deckInput.value = ''; updateInputStats(); hideResults(); });
    backBtn.addEventListener('click', function () { inputSection.style.display = 'block'; hideResults(); });
    addAllBtn.addEventListener('click', addAllFoundCardsToCart);

    searchBtn.addEventListener('click', function () {
      var deckList = parseDeckList(deckInput.value);
      if (!deckList.length) { alert('Please enter a deck list first!'); return; }
      showLoading();
      loadIndex().then(function (l) {
        lookup = l;
        matchDeck(deckList);
        displayResults();
      }).catch(function (e) {
        console.error('Deckbuilder index error:', e);
        alert('Could not load the card catalog. Please try again in a moment.');
      }).then(hideLoading);
    });

    function matchDeck(deckList) {
      searchResults = []; missingCards = [];
      deckList.forEach(function (card) {
        var offers = offersFor(lookup, card.cardName);
        if (!offers.length) { missingCards.push(card); return; }
        var best = offers[0];
        searchResults.push({
          originalLine: card.originalLine, originalCardName: card.cardName,
          quantity: card.quantity, offer: best,
          available: Math.min(card.quantity, best.qty), stockShort: best.qty < card.quantity
        });
      });
    }

    function totalCost() {
      return searchResults.reduce(function (s, r) { return s + r.offer.price * r.available; }, 0);
    }

    function displayResults() {
      foundCount.textContent = searchResults.length + ' found';
      missingCount.textContent = missingCards.length + ' missing';
      totalPrice.textContent = money(totalCost()) + ' total';
      addAllBtn.disabled = searchResults.length === 0;
      resultsGrid.innerHTML = '';
      searchResults.forEach(function (r, i) { resultsGrid.appendChild(createCardElement(r, i)); });
      missingList.innerHTML = '';
      missingCards.forEach(function (c) {
        var el = document.createElement('div');
        el.className = 'missing-card-item';
        el.innerHTML = '<div class="card-name">' + escapeHtml(c.cardName) + '</div>' +
          '<span class="card-quantity">' + c.quantity + 'x</span>';
        missingList.appendChild(el);
      });
      missingCardsSection.style.display = missingCards.length ? 'block' : 'none';
      inputSection.style.display = 'none';
      resultsSection.style.display = 'block';
    }

    function createCardElement(r, index) {
      var o = r.offer;
      var el = document.createElement('div');
      el.className = 'deckbuilder-card found' + (r.stockShort ? ' stock-short' : '');
      el.innerHTML =
        '<div class="card-quantity">' + r.available + 'x</div>' +
        (o.image ? '<img src="' + escapeHtml(o.image) + '" alt="' + escapeHtml(o.title) + '" class="card-image" loading="lazy">' : '<div class="card-image"></div>') +
        '<div class="card-info">' +
          '<h3>' + escapeHtml(o.title) + '</h3>' +
          '<div class="card-variant-info">' + escapeHtml(o.variantTitle) + '</div>' +
          '<div class="card-price">' + money(o.price) + ' each</div>' +
          '<div class="card-variant-info">Total: ' + money(o.price * r.available) +
            (r.stockShort ? ' <span class="stock-warning">(only ' + o.qty + ' in stock, wanted ' + r.quantity + ')</span>' : '') + '</div>' +
          '<div class="card-actions">' +
            '<button type="button" class="btn btn-primary btn-small" data-add="' + index + '">Add ' + r.available + ' to Cart</button>' +
            '<button type="button" class="btn btn-secondary btn-small" data-alt="' + index + '">Alternatives</button>' +
            '<a href="' + escapeHtml(o.url) + '" class="btn btn-secondary btn-small" target="_blank">View Product</a>' +
          '</div>' +
        '</div>';
      return el;
    }

    resultsGrid.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      if (btn.dataset.add !== undefined) {
        var r = searchResults[+btn.dataset.add];
        btn.disabled = true;
        addToCart([{ id: r.offer.variantId, quantity: r.available }]).then(function (res) {
          btn.textContent = res.failed.length ? 'Not available' : 'Added!';
        });
      } else if (btn.dataset.alt !== undefined) {
        showAlternatives(+btn.dataset.alt);
      }
    });

    // ---- cart ----
    function postCart(items) {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }

    // One request for everything; if Shopify rejects the batch (an item sold out since the
    // index was built), fall back to one item at a time so the rest still goes in.
    function addToCart(items) {
      var failed = [];
      return postCart(items).then(function (res) {
        if (res.ok) return;
        return items.reduce(function (p, item) {
          return p.then(function () {
            return postCart([item]).then(function (r) { if (!r.ok) failed.push(item); });
          });
        }, Promise.resolve());
      }).then(function () {
        return updateCartCount();
      }).then(function () {
        if (window.cartNotification && window.cartNotification.renderContents) window.cartNotification.renderContents();
        return { failed: failed };
      });
    }

    function addAllFoundCardsToCart() {
      if (!searchResults.length) return;
      addAllBtn.disabled = true;
      addAllBtn.textContent = 'Adding to Cart...';
      var items = searchResults.map(function (r) { return { id: r.offer.variantId, quantity: r.available }; });
      addToCart(items).then(function (res) {
        var ok = items.length - res.failed.length;
        addAllBtn.textContent = ok ? 'Added ' + ok + ' cards!' + (res.failed.length ? ' (' + res.failed.length + ' sold out)' : '') : 'Nothing could be added';
        if (res.failed.length) {
          var failedIds = res.failed.map(function (f) { return f.id; });
          searchResults.forEach(function (r, i) {
            if (failedIds.indexOf(r.offer.variantId) >= 0) resultsGrid.children[i].classList.add('sold-out');
          });
        }
      }).catch(function (e) {
        console.error('Cart error:', e);
        alert('Error adding cards to cart. Please try again.');
        addAllBtn.disabled = false;
        addAllBtn.textContent = 'Add All Found Cards to Cart';
      });
    }

    function updateCartCount() {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count, #sticky-cart-count, .cart-count-bubble').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      }).catch(function () { /* ignore */ });
    }

    // ---- alternatives (other printings / conditions, from the index, no requests) ----
    var modal = $('alternatives-modal'), altTitle = $('alternatives-title'), altGrid = $('alternatives-grid');
    var altLoading = $('alternatives-loading');

    function showAlternatives(resultIndex) {
      var r = searchResults[resultIndex];
      var offers = offersFor(lookup, r.originalCardName);
      altTitle.textContent = 'All offers for "' + r.originalCardName + '"';
      modal.style.display = 'flex';
      document.documentElement.classList.add('db-modal-open');
      altLoading.style.display = 'none';
      altGrid.innerHTML = '';
      offers.forEach(function (o, i) {
        var el = document.createElement('div');
        el.className = 'alternative-card' + (o.variantId === r.offer.variantId ? ' selected' : '');
        el.innerHTML =
          (o.image ? '<img src="' + escapeHtml(o.image) + '" alt="' + escapeHtml(o.title) + '" class="alternative-card-image" loading="lazy">' : '<div class="alternative-card-image"></div>') +
          '<h4>' + escapeHtml(o.title) + '</h4>' +
          '<div class="alternative-card-variant">' + escapeHtml(o.variantTitle) + ' &middot; ' + o.qty + ' in stock</div>' +
          '<div class="alternative-card-price">' + money(o.price) + ' each</div>' +
          '<div class="alternative-card-actions">' +
            '<button type="button" class="btn btn-success btn-small" data-use="' + i + '">Use This Card</button>' +
            '<a href="' + escapeHtml(o.url) + '" class="btn btn-secondary btn-small" target="_blank">View</a>' +
          '</div>';
        el.querySelector('[data-use]').addEventListener('click', function () {
          r.offer = o;
          r.available = Math.min(r.quantity, o.qty);
          r.stockShort = o.qty < r.quantity;
          displayResults();
          closeAlternativesModal();
        });
        altGrid.appendChild(el);
      });
    }

    function closeAlternativesModal() {
      modal.style.display = 'none';
      document.documentElement.classList.remove('db-modal-open');
    }
    window.closeAlternativesModal = closeAlternativesModal;

    // ---- loading / visibility ----
    function showLoading() {
      loadingIndicator.style.display = 'block';
      resultsSection.style.display = 'none';
      searchBtn.disabled = true;
      searchBtn.textContent = 'Searching...';
    }
    function hideLoading() {
      loadingIndicator.style.display = 'none';
      searchBtn.disabled = false;
      searchBtn.textContent = 'Search Cards';
    }
    function hideResults() {
      resultsSection.style.display = 'none';
      addAllBtn.disabled = true;
      addAllBtn.textContent = 'Add All Found Cards to Cart';
    }
  });
})();
